<template>
    <div class="document-container" v-if="$store.state.is_manager">
        <div class="edit-document-button" :class="scroll.headerFixed?'fix-button-top':''">
            <el-button type="success" @click="updateContent" icon="el-icon-check" class="circle-button"
                       title="保存"></el-button>
            <el-button type="danger" @click="goBack" icon="el-icon-close" class="circle-button" title="取消"></el-button>
        </div>
        <div class="document-title">
            <el-row style="height: 60px;">
                <el-col :span="20">
                    <input placeholder='标题' style="outline:none" class='documentTitle' v-model="title"/>
                </el-col>
            </el-row>
        </div>
        <hr>
        <div class="document-content">
            <div class="toolbar" id="toolbar" :class="scroll.headerFixed?'isFixed':''"></div>
            <div class="wrapper">
                <div class="editor" id="editor" ref="content"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import {Editor} from "@mtfe/citadel-editor"
    import {buildToolbar} from "@mtfe/citadel-editor/lib/toolbar"
    import axios from "axios";
    import {mapState} from "vuex";

    export default {
        name: "updateDocument",
        mounted: function () {
            window.addEventListener('scroll', this.handleScroll);
            var vm = this;
            if (!(vm.$store.state.is_manager)) {
                this.$notify({
                    title: '没有权限',
                    message: '你没有操作当前菜单的权限',
                    type: 'error'
                });
                return;
            }
            if (vm.token === "") {
                var token = this.getCookie("access-token");
                if (token != null) {
                    vm.$store.commit('UPDATETOKEN', token);
                    vm.token = token;
                }
            }
            // 加载页面内用
            vm.currentIndex = this.$route.query.index;
            axios.get(vm.selectDocument, {
                withCredentials: true,
                params: {"documentIndex": vm.currentIndex, "language": ""},
            }).then((response) => {
                if (response.data && response.data.status === 401) {
                    document.cookie = "currentURL=updateDocument?index=" + vm.currentIndex;
                    window.location = vm.loginRediret;
                    return;
                }
                if (response.data.code === 2) {
                  if (response.data.message !== '查询成功') {
                    vm.$notify({
                      title: '提示(Notice)',
                      message: "无对应语言页面，显示当前页面～(No corresponding language page available, displaying the current page~)",
                      type: 'warning',
                      customClass: 'notify-warning'
                    });
                  }
                    vm.documentContent = response.data.data.documentContent;
                    vm.title = response.data.data.documentTitle;
                    const $editor = document.querySelector("#editor");
                    const $toolbarWrapper = document.querySelector("#toolbar");
                    const editor = new Editor($editor, {
                        defaultValue: vm.documentContent,
                        moduleConfigs: {
                            image: {
                                customUpload: async function ({file, onprogress, insert, failedHandle}) {
                                    try {
                                        const result = await new Promise(res => {
                                            setTimeout(async () => {
                                                const rest = await vm.uploadFileToS3(file, onprogress);
                                                res(rest);
                                            }, 2000);
                                        });
                                        await insert({
                                            src: result
                                        });
                                    } catch (e) {
                                        failedHandle(`some errors: ${e}`);
                                    }
                                }
                            }
                        }
                    });
                    buildToolbar({
                        $toolbarWrapper,
                        getEditorCore: () => editor,
                    });
                    vm.editor = editor;
                } else {
                    vm.$notify({
                        title: '提示',
                        message: '显示文档失败！',
                        type: 'error'
                    });
                }
            }).catch(function (error) {
                vm.requesterrorinfo(error)
            });
            vm.buildScrollData();
        },
        computed: mapState({
            updateDocument: function (state) {
                return state.updateDocument;
            },
            selectDocument: function (state) {
                return state.selectDocument;
            },
            uploadImage: function (state) {
                return state.uploadImage;
            },
        }),
        methods: {
            buildScrollData() {
                let vm = this;
                // 监听dom渲染完成
                this.$nextTick(function () {
                    // 这里fixedHeaderRoot是吸顶元素的ID
                    let header = document.getElementById("toolbar");
                    // 这里要得到top的距离和元素自身的高度
                    vm.scroll.offsetTop = header.offsetTop;
                    vm.scroll.offsetHeight = header.offsetHeight;
                });
            },
            handleScroll() {
                // 得到页面滚动的距离
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                // 判断页面滚动的距离是否大于吸顶元素的位置
                this.scroll.headerFixed = scrollTop > (this.scroll.offsetTop - this.scroll.offsetHeight);

            },
            getCookie(name) {
                var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
                if (arr = document.cookie.match(reg))
                    return unescape(arr[2]);
                else
                    return null;
            },
            updateContent() {
                var vm = this;
                var htmlInfo = vm.editor.value();
                var document = {documentIndex: vm.currentIndex, documentContent: htmlInfo, documentTitle: vm.title};
                axios.post(vm.updateDocument, document, {
                    withCredentials: true
                }).then((response) => {
                    if (response.data.code === 2) {
                        vm.$notify({
                            title: '提示',
                            message: '修改成功！',
                            type: 'success'
                        });
                        this.$router.push({path: '/templateHtml', query: {index: vm.currentIndex}});
                    } else {
                        let message = '修改失败！';
                        if (response.data && response.data.message) {
                            message = response.data.message + '!';
                        }
                        vm.$notify({
                            title: '提示',
                            message: message,
                            type: 'error'
                        });
                    }
                }).catch(function (error) {
                    vm.requesterrorinfo(error)
                });
            },
            goBack() {
                this.$router.go(-1);
            },
            requesterrorinfo(error) {
                var vm = this;
                if (error.response) {
                    var code = error.response.status;
                    if (code === 401) {
                        document.cookie = "currentURL=updateDocument?index=" + vm.currentIndex;
                        window.location = vm.loginRediret;
                    } else {
                        if (code === 404) {
                            vm.$notify({
                                title: '提示',
                                message: '404:Not found!',
                                type: 'error'
                            });
                        } else {
                            vm.$notify({
                                title: '提示',
                                message: '501:服务端未响应!',
                                type: 'error'
                            });
                        }
                    }
                } else {
                    vm.$notify({
                        title: '提示',
                        message: '502:服务端未响应!',
                        type: 'error'
                    });
                }
            },
            async uploadFileToS3(file, onprogress) {
                let vm = this;
                let formData = new FormData();
                formData.append('file', file);
                let response = await axios.post(vm.uploadImage, formData, {
                    withCredentials: true,
                    headers: {'Content-Type': 'multipart/form-data'}
                });
                if (response.data.code === 0) {
                    return response.data.data;
                } else {
                    vm.$message.error(response.data.message);
                    return null;
                }
            }
        },
        data() {
            return {
                token: '',
                title: '标题',
                documentContent: '',
                currentIndex: '',
                editor: null,
                scroll: {
                    offsetTop: 0,
                    offsetHeight: 0,
                    headerFixed: false
                }
            }
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll);
        },
    }
</script>

<style scoped>
    input.documentTitle {
        margin: 16px 0 8px;
        border: 0;
        font-size: 32px !important;
        font-weight: 700;
        background: none;
        resize: none;
        padding: 0 30px;
        width: 100%;
    }

    input.documentTitle:focus {
        border: none;
    }

    .edit-document-button {
        position: fixed;
        top: 100px;
        right: 60px;
        z-index: 1899;
    }

    .fix-button-top {
        top: 160px;
    }

    .isFixed {
        position: fixed;
        top: 60px;
        left: 300px;
        right: 20px;
        z-index: 1899;
    }

    #toolbar {
        background-color: rgba(255, 255, 255, 1);
    }

    .el-button.circle-button {
        padding: 12px !important;
        border-radius: 50% !important;
    }
</style>



// WEBPACK FOOTER //
// updateDocument.vue?31851830